export const ARTICLE_LIST_UPDATE = 'ARTICLE_LIST_UPDATE'
export const ARTICLE_UPDATE_PROPS = 'ARTICLE_UPDATE_PROPS'
export const ARTICLE_CLEAN = 'ARTICLE_CLEAN'
